<template>
  <h-dialog
    class="FilingInfo"
    :title="regionData.name"
    v-model="dialogVisble"
    height="80vh"
    width="74vw"
    zIndex="100"
    @close="close"
  >
    <div class="houseDialog">
      <div class="houseTop">
        <div class="houseTitle">
          <span class="houseColor">共计</span>
          <span class="houseBlue"
            >{{ regionData.endFloor }}层
            {{ regionData.endFloor * regionData.roomNum }}户</span
          >
        </div>
        <div class="houseTitle">
          <span class="houseColor">实有人口</span>
          <span class="houseBlue">{{ houseTotalNum.value }}</span>
        </div>
        <div class="houseTitle">
          <span class="houseColor">租户占比</span>
          <span class="houseBlue">{{ houseTotalNum.zy }}%</span>
        </div>
        <div class="houseTitle">
          <span class="houseColor">闲置率</span>
          <span class="houseBlue">{{ houseTotalNum.xzl }}%</span>
        </div>
      </div>
      <div class="houseBottm">
        <div class="houseLeft">
          <div class="leftTop">
            <el-form
              :inline="true"
              ref="formRef"
              :model="tableParams"
              class="demo-form-inline"
            >
              <el-select
                v-model="unitSelect"
                class="marginrow"
                placeholder="请选择"
                @change="unitChange(unitSelect)"
              >
                <el-option
                  v-for="item in unitList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.regionId"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="floorSelect"
                class="marginrow"
                placeholder="请选择"
                @change="floorChange"
              >
                <el-option
                  v-for="item in floorOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form>
            <div class="leftLable">
              <div class="lableItem"><span class="blue"></span>自住</div>
              <div class="lableItem"><span class="yellow"></span>空闲</div>
              <div class="lableItem"><span class="red"></span>出租</div>
            </div>
          </div>
          <div class="leftBottom">
            <!-- :class="['peopleItem',typeClass[item.type],{current: select.id === item.id}]" -->
            <div
              :class="['peopleItem']"
              v-for="(item, index) in houseUnitList"
              :key="index"
              @click="clickItem(item, index)"
            >
              <span :class="{ white: index == clickIndex }">{{
                item.roomNum
              }}</span>
              <span class="borderColor"></span>
              <span :class="{ white: index == clickIndex }"
                >{{ item.prisonNum ? item.prisonNum : 0 }}人</span
              >
              <div
                :class="[
                  'bgImg',
                  typeClass[item.houseLive],
                  {
                    opacitys: hoverItem === item.prisonNum,
                  },
                ]"
              ></div>
            </div>
          </div>
        </div>
        <div class="houseRight">
          <div class="rightTitle" v-if="houseInfo">
            {{ houseInfo.roomNum }}居住人员列表
          </div>

          <div
            class="rightBox"
            v-if="houseInfo && houseInfo.prisonInfoList.length > 0"
          >
            <div
              class="peopleList"
              v-for="item in houseInfo.prisonInfoList"
              :key="item.cardNumber"
            >
              <img :src="item.imageUrl" />

              <div class="peopleTitle">
                <div class="peopleName">{{ item.name }}</div>
                <div class="peoplerow">
                  <span>{{ item.ageTypeDict }}</span>
                  <span>{{ item.sexDict }}</span>
                  <span>{{ item.relationDict }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </h-dialog>
</template>
<script >
import { defineComponent, reactive, toRefs, watchEffect, computed } from "vue";
import {
  queryUserList,
  regionselect,
  regioninfoinfo,
  infoQuery,
} from "@/api/realHouse/realHouse";
import { listByRegionId } from "@/api/system/region";
// import { queryUserList } from "@/api/realPopulation/realPopulation";
import { listWarning } from "@/api/publicSecurityResearch/suspectedGroup.js";
import {
  prisonTotalNum,
  houseLive,
} from "@/api/dataAnalysis/housingAnalysis.js";
import moment from "moment";
import _ from "lodash";
export default defineComponent({
  name: "",
  components: {},
  props: {
    Id: {
      type: String,
      default: "",
    },
    visiable: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const data = reactive({
      houseUnitList: [
        // { name: "101", number: "5", type: "1", color: "" },
        // { name: "102", number: "0", type: "2", color: "" },
        // { name: "103", number: "4", type: "3", color: "" },
        // { name: "105", number: "1", type: "1", color: "" },
        // { name: "108", number: "3", type: "1", color: "" },
        // { name: "202", number: "2", type: "1", color: "" },
        // { name: "204", number: "2", type: "1", color: "" },
        // { name: "208", number: "1", type: "1", color: "" },
        // { name: "305", number: "3", type: "1", color: "" },
      ],
      resUnitList: [],
      typeClass: {
        0: "blue",
        1: "red",
        4: "yellow",
      },
      hoverItem: "",
      clickIndex: "",
      tableParams: {
        optionsValue: "1",
        options2Value: "1",
      },
      unitList: [],
      unitSelect: "",
      floorSelect: "",
      floorOptions: [{ value: 0, label: "不限" }],
      regionData: {
        name: "",
        endFloor: 0,
        roomNum: 0,
      },
      dialogVisble: false,
      houseInfo: null, //房屋信息
      houseTotalNum: {
        value: 0,
        zy: 0, //租户占比
        xzl: 0, //闲置率
      }, //时有人口
      houseLive: [], //居住现状
      // numList: ["一", "二", "三", "四", "五", "六", "七", "八", "九"],
    });

    const refData = toRefs(data);
    watchEffect(() => {
      data.dialogVisble = props.visiable;
    });
    const floorData = () => {
      for (let index = 0; index < data.regionData.endFloor; index++) {
        data.floorOptions.push({ value: index + 1, label: `${index + 1}层` });
      }
    };
    const queryUserListAsync = async () => {
      let params = {
        regionId: props.Id,
        limit: 999,
        page: 1,
      };
      let selectParams = {
        parentId: props.Id,
        allowpage: true,
      };
      let totalParams = {
        regionId: props.Id,
      };
      const res = await queryUserList(params);
      const ress = await regioninfoinfo(props.Id);
      const resSelect = await regionselect(selectParams);
      const resTotalNum = await prisonTotalNum(totalParams); //居住人数
      const resHouseLive = await houseLive(totalParams); //居住现状
      // data.houseUnitList = res.page.list;
      data.regionData = ress.regionInfo;
      data.unitList = resSelect.data.filter((item, index) => {
        return index != 0;
      });
      data.houseTotalNum = resTotalNum.data;
      data.houseLive = resHouseLive.data;
      handleHouseTotalNum(resHouseLive.data);
      console.log(res);
      floorData();
      if (data.unitList.length > 0) {
        data.unitSelect = data.unitList[0].regionId;
        unitChange(data.unitList[0].regionId);
      }
    };
    const handleHouseTotalNum = (list) => {
      console.log(data.houseTotalNum, 1111);
      console.log(list, 1111);
      if (data.houseTotalNum.value == 0) {
        data.houseTotalNum.zy = 0;
        data.houseTotalNum.xzl = 0;
        return;
      }
      data.houseTotalNum.zy = 0;
      data.houseTotalNum.xzl = 0;
      list.forEach((item) => {
        if (item.name === "租用") {
          data.houseTotalNum.zy = parseFloat(
            (item.value / data.houseTotalNum.value) * 100
          ).toFixed(2);
          console.log(data.houseTotalNum.zy);
        }
        if (item.name === "空置") {
          data.houseTotalNum.xzl = parseFloat(
            (item.value / data.houseTotalNum.value) * 100
          ).toFixed(2);
        }
      });
    };
    //改变下拉框一数据
    const unitChange = async (value) => {
      let params = {
        regionId: value,
        // startDate: moment(new Date()).format("YYYY-MM-DD"),
        // endDate: moment(new Date()).format("YYYY-MM-DD"),
        // threshold: 0,
        allowpage: true,
      };
      const res = await queryUserList(params);
      data.resUnitList = res.page.list;
      floorChange();
      if (data.houseUnitList.length > 0) {
        clickItem(data.houseUnitList[0], 0);
      }
    };
    //改变下拉框二数据
    const floorChange = () => {
      data.houseUnitList = _.cloneDeep(data.resUnitList);
      console.log(data.houseUnitList);
      console.log(data.floorSelect);
      data.houseUnitList = data.houseUnitList.filter((item) => {
        if (data.floorSelect == 0) {
          return item;
        } else if (item.floor == data.floorSelect) {
          return item;
        }
      });
    };
    queryUserListAsync();
    const clickItem = async (item, index) => {
      data.clickIndex = index;
      const res = await infoQuery(item.houseId);
      if (res.code == 0) {
        res.houseInfo.prisonInfoList.forEach((item) => {
          item.imageUrl = window.imgURL + item.imageUrl;
        });
        data.houseInfo = res.houseInfo;
      }
    };
    const close = (item) => {
      emit("update:visiable", false);
    };
    return {
      ...refData,
      clickItem,
      unitChange,
      close,
      floorChange,
    };
  },
});
</script>
<style  lang='scss' scoped >
.houseDialog {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .houseTop {
    height: 100px;
    width: 100%;
    border-bottom: 1px solid #6a7795;
    display: flex;
    justify-content: center;
    .houseTitle {
      display: flex;
      flex-direction: column;
      width: 147px;
      height: 75px;
      margin: 0 10px;
      justify-content: space-evenly;
      align-items: center;
      font-weight: bold;
      background-image: url("~@/assets/images/home/house.png");
      .houseColor {
      }
    }
  }
  .houseBlue {
    color: #22f6f4;
  }
  .white {
    color: #22f6f4;
  }
  .houseBottm {
    width: 100%;
    display: flex;
    flex: 1;
    height: 90%;

    .houseLeft {
      flex: 1;
      display: flex;
      flex-direction: column;
      height: 100%;
      .leftTop {
        height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .leftLable {
          display: flex;
          .lableItem {
            margin-right: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            span {
              width: 10px;
              height: 10px;
              border-radius: 10px;
              margin-right: 5px;
            }
            .blue {
              background: #00d2ff;
            }
            .yellow {
              background: #edc30f;
            }
            .red {
              background: #d33434;
            }
          }
        }
      }
      .leftBottom {
        // flex: 1;
        overflow: auto;
        display: flex;
        flex-wrap: wrap;

        .peopleItem {
          width: 113px;
          height: 69px;
          margin: 10px;
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          align-items: center;
          position: relative;
          cursor: pointer;
          .bgImg {
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: -1;
            opacity: 0.5;
            background-image: url("~@/assets/images/home/blue.png");
            &.blue {
              background-image: url("~@/assets/images/home/blue.png");
            }
            &.red {
              background-image: url("~@/assets/images/home/red.png");
            }
            &.yellow {
              background-image: url("~@/assets/images/home/yellow.png");
            }
            &.opacitys {
              opacity: 1;
            }
          }
          .borderColor {
            width: 50px;
            height: 1px;
            background: #00d2ff;
          }
        }
      }
    }
    .houseRight {
      width: 300px;
      height: 100%;
      border-left: 1px solid #6a7795;
      display: flex;
      flex-direction: column;
      .rightTitle {
        width: 100%;
        line-height: 40px;
        text-align: center;
      }
      .rightBox {
        flex: 1;
        overflow: auto;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        justify-content: space-between;
        padding: 0 12px;
        .peopleList {
          width: 130px;
          height: 168px;
          position: relative;
          margin-bottom: 10px;
          img {
            width: 100%;
            height: 100%;
          }
          .peopleTitle {
            width: 100%;
            position: absolute;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            padding: 5px;
            .peoplerow {
              display: flex;
              justify-content: space-around;
            }
          }
        }
      }
    }
  }
  :deep(.el-input__inner) {
    &::placeholder {
      color: #fff;
    }

    &::-webkit-input-placeholder {
      /* WebKit browsers 适配谷歌 */
      color: #fff;
    }

    &:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 适配火狐 */
      color: #fff;
    }

    &::-moz-placeholder {
      /* Mozilla Firefox 19+ 适配火狐 */
      color: #fff;
    }

    &:-ms-input-placeholder {
      /* Internet Explorer 10+  适配ie*/
      color: #fff;
    }
  }
  :deep(input) {
    background-color: rgba(62, 121, 191, 0) !important;
    border: 1px solid #6a7795;
    color: #fff;
  }
  .marginrow {
    margin-right: 20px;
  }
  :deep(.el-select-dropdown__item) {
    color: #fff !important;
  }
  :deep(.el-select-dropdown__item.hover, .el-select-dropdown__item:hover) {
    background: none !important;
  }
}
</style>